<!--
  黑金 V1 · 选择用餐人数
  业务逻辑复用 InputPeopleNum，样式对齐 BlackMicropoint / BlackCurrentConsume
-->
<template>
  <div class="black-people-page">
    <header class="black-people-hero">
      <img src="@/assets/images/point-user.png" alt="" class="black-people-avatar" />
      <p class="black-people-welcome">亲爱的顾客，欢迎您用餐～</p>
      <p v-if="deskCodeText" class="black-people-desk">桌台号：{{ deskCodeText }}</p>
    </header>

    <section class="black-people-panel">
      <h1>请问您几人用餐？</h1>
      <p class="black-people-tip">请选择人数</p>

      <div class="black-people-grid">
        <button
          v-for="item in 11"
          :key="item"
          type="button"
          :class="{ active: tableNumber == item }"
          @click="onClickTableNumber(item)"
        >
          {{ item }}
        </button>
        <button
          type="button"
          :class="{ active: tableNumber == 'more' }"
          @click="onClickTableNumber('more')"
        >
          更多
        </button>
      </div>

      <div v-if="tableNumber == 'more'" class="black-people-input-wrap">
        <input
          v-model="inputTableNumber"
          type="number"
          inputmode="numeric"
          maxlength="3"
          placeholder="请输入人数"
        />
      </div>

      <button type="button" class="gold-button" @click="handleToOrderPage">
        {{ submitText }}
      </button>
    </section>

    <van-overlay
      :show="showSelectModal"
      z-index="5"
      class="black-people-overlay"
      :style="overlayStyle"
    >
      <div class="black-people-dialog">
        <strong>温馨提示</strong>
        <ul>
          <li>合理点餐，请勿浪费食物～</li>
          <li>未成年人请勿饮酒！</li>
        </ul>
        <div class="black-people-dialog-iKnow">
          <button type="button" class="gold-button dialog-btn iKnow-btn" @click="closedailog">
            我已知悉
          </button>
        </div>
      </div>
    </van-overlay>
<!-- 去掉弹框提示 ，这不是团队点餐，是是否有历史订单提示-->
    <!-- <van-overlay
      :show="showEnableTeamOrder"
      z-index="999"
      class="black-people-overlay"
      :style="overlayStyle"
    >
      <div class="black-people-dialog">
        <strong>温馨提示</strong>
        <p class="black-people-dialog-copy">
          您好，这张桌子已经有人点过餐，请问您还要继续点餐吗？
        </p>
        <div class="black-people-dialog-actions">
          <button
            type="button"
            class="outline-button dialog-btn"
            @click="showEnableTeamOrder = false"
          >
            继续点餐
          </button>
          <button type="button" class="gold-button dialog-btn" @click="goToHistouryConsume">
            查看已点餐品
          </button>
        </div>
      </div>
    </van-overlay> -->
  </div>
</template>

<script>
import InputPeopleNum from "./InputPeopleNum.vue";
import {
  getBlackMicropointRouteName,
  getBlackRecordConsumeRouteName,
  handleSessionStorage,
} from "@/utils";

export default {
  name: "BlackInputPeopleNum",
  extends: InputPeopleNum,
  data() {
    return {
      previousPageChromeTheme: null,
      overlayStyle: {
        backgroundColor: "rgba(0, 0, 0, 0.76)",
      },
    };
  },
  computed: {
    deskCodeText() {
      const deskCode = handleSessionStorage.get("deskCode");
      return deskCode && deskCode.code ? deskCode.code : "";
    },
    submitText() {
      if (this.fromPage === "NewPlaceOrder" && !this.isFromMicropoint) {
        return "确定";
      }
      return this.isFromMicropoint ? "继续下单" : "开始点餐";
    },
  },
  mounted() {
    this.applyPageChromeTheme();
  },
  beforeDestroy() {
    this.restorePageChromeTheme();
  },
  methods: {
    applyPageChromeTheme() {
      this.previousPageChromeTheme = {
        htmlBackground: document.documentElement.style.backgroundColor,
        bodyBackground: document.body.style.backgroundColor,
      };
      document.documentElement.style.backgroundColor = "#171717";
      document.body.style.backgroundColor = "#171717";
    },
    restorePageChromeTheme() {
      if (!this.previousPageChromeTheme) return;
      document.documentElement.style.backgroundColor =
        this.previousPageChromeTheme.htmlBackground;
      document.body.style.backgroundColor =
        this.previousPageChromeTheme.bodyBackground;
    },
    goToHistouryConsume() {
      this.showEnableTeamOrder = false;
      this.$router.push({
        name: getBlackRecordConsumeRouteName(),
        query: this.saasCode
          ? { saasCode: this.saasCode, diningRoomId: this.diningRoomId }
          : { diningRoomId: this.diningRoomId },
      });
    },
    handleToOrderPage() {
      if (this.tableNumber == "more" && !this.inputTableNumber) {
        this.$toast("请输入就餐人数");
        return;
      }
      this.handleChangePeopleNum();
      this.$router.replace({
        name: getBlackMicropointRouteName(),
        query: this.saasCode
          ? { saasCode: this.saasCode, diningRoomId: this.diningRoomId }
          : { diningRoomId: this.diningRoomId },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.black-people-page {
  min-height: 100vh;
  padding: 40px 24px calc(40px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  color: #f7f4ee;
  background-color: #202120;
  background-image: url("~@/assets/black-micropoint/bg.png");
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% auto;
  color-scheme: dark;
  font-family: "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
}

.black-people-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 36px;
  text-align: center;
}

.black-people-avatar {
  width: 120px;
  height: 120px;
  margin-bottom: 40px;
}

.black-people-welcome {
  margin: 0 0 20px;
  color: #e2ddd3;
  font-size: 28px;
  line-height: 40px;
}

.black-people-desk {
  margin: 0;
  color: #f1ca63;
  font-size: 30px;
  font-weight: 600;
}

.black-people-panel {
  padding: 46px 24px 40px;
  border: 1px solid rgba(226, 187, 91, 0.25);
  border-radius: 8px;
  background: rgba(35, 35, 35, 0.78);

  h1 {
    margin: 0;
    color: #f7f4ee;
    font-size: 34px;
    font-weight: 600;
    text-align: center;
  }
}

.black-people-tip {
  position: relative;
  margin: 68px 0 32px;
  color: #aaa7a2;
  text-align: center;
  font-size: 24px;

  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    width: 72px;
    height: 1px;
    background: rgba(226, 187, 91, 0.35);
  }

  &::before {
    left: 12%;
  }

  &::after {
    right: 12%;
  }
}

.black-people-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-bottom: 24px;

  button {
    height: 54px;
    border: 1px solid #555;
    border-radius: 5px;
    color: #dededb;
    background: rgba(48, 48, 48, 0.78);
    font-size: 24px;

    &.active {
      border-color: #edc45c;
      color: #f4ca60;
      background: #4b4029;
    }
  }
}

.black-people-input-wrap {
  margin-bottom: 28px;

  input {
    width: 100%;
    height: 62px;
    padding: 0 18px;
    border: 1px solid #555;
    border-radius: 5px;
    box-sizing: border-box;
    color: #fff;
    background: rgba(48, 48, 48, 0.78);
    font-size: 24px;
    outline: 0;

    &::placeholder {
      color: #858585;
    }

    &:focus {
      border-color: #edc45c;
    }
  }
}

.gold-button {
  display: block;
  width: 100%;
  height: 68px;
  padding: 0 24px;
  margin-top: 82px;
  border: 0;
  border-radius: 34px;
  color: #32394b;
  background: linear-gradient(135deg, #f8d57b, #efb94f);
  font-size: 27px;
  font-weight: 600;

  &.dialog-btn {
    width: auto;
    min-width: 220px;
    margin-top: 0;
  }
  &.iKnow-btn{
    margin: 0 auto;
  }
}

.outline-button {
  min-width: 220px;
  height: 68px;
  padding: 0 24px;
  border: 1px solid #caa64e;
  border-radius: 34px;
  color: #e2bd60;
  background: transparent;
  font-size: 23px;
  font-weight: 600;
}

.black-people-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
}

.black-people-dialog {
  width: 100%;
  max-width: 640px;
  padding: 32px 28px 28px;
  border: 1px solid rgba(226, 187, 91, 0.28);
  border-radius: 8px;
  background: rgba(35, 35, 35, 0.96);
  color: #f7f4ee;

  > strong {
    display: block;
    margin-bottom: 24px;
    color: #f1ca63;
    font-size: 32px;
    text-align: center;
  }

  ul {
    margin: 0 0 82px;
    padding: 0;
    list-style: none;

    li {
      position: relative;
      padding-left: 22px;
      color: #d7d3ca;
      font-size: 26px;
      line-height: 42px;

      &::before {
        content: "";
        position: absolute;
        top: 18px;
        left: 0;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #f0c75d;
      }

      & + li {
        margin-top: 8px;
      }
    }
  }
}

.black-people-dialog-copy {
  margin: 0 0 36px;
  color: #d7d3ca;
  font-size: 26px;
  line-height: 40px;
  text-align: center;
}

.black-people-dialog-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.black-people-dialog-iKnow {
  text-align: center;
}
</style>
